import styled from "styled-components";
import {NavbarSeparatorDefaultBox} from "./navbar-separator.default.box";

export const NavbarSeparatorMrGreenBox = styled(NavbarSeparatorDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    margin-left: 1rem;
    padding-left: 1rem;
  }
`